module.exports = "<div data-bind=\"css: model.css.progress\">\n    <div data-bind=\"css: model.css.progressBar, style:{ width: model.progressValue + '%' }\"\n        role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n        <span data-bind=\"text: model.progressText, css: model.css.progressText + ' ' + model.css.progressTextInBar\"></span>\n    </div>\n    <span data-bind=\"text: model.progressText, css: model.css.progressText + ' ' + model.css.progressTextUnderBar\"></span>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader?interpolate!./~/val-loader!./src/knockout/components/progress/progress.html
// module id = 157
// module chunks = 0